import { DisciplineFilterOptionInformation } from '@studyportals/search-filters';
import { Discipline } from './Discipline';
import FiltersDataPresenter from '@/study-search/presenters/FiltersDataPresenter';

class DisciplineFilterOptionInformationFactory {
	private filtersDataPresenter = FiltersDataPresenter;
	private disciplineFilterOptionInformation: DisciplineFilterOptionInformation[] = [];

	public getDisciplineFilterInformation(): DisciplineFilterOptionInformation[] {
		const disciplines = this.filtersDataPresenter.getDisciplines();
		this.disciplineFilterOptionInformation = this.generateDisciplineFilterOptionInformation(disciplines);

		return this.disciplineFilterOptionInformation;
	}

	public getDisciplineFilterOptionValues(): string[] {
		return this.disciplineFilterOptionInformation.map((_) => _.optionValue);
	}

	private generateDisciplineFilterOptionInformation(disciplines: Discipline[]): DisciplineFilterOptionInformation[] {
		const orderedDisciplines = this.orderDisciplines(disciplines);

		return orderedDisciplines.map(
			(_) => new DisciplineFilterOptionInformation(_.name, _.identity, _.virtualPath, _.name, _.parentIdentity, _.icon, _.synonym ?? ''),
		);
	}

	private orderDisciplines(discipline: Discipline[]): Discipline[] {
		const mainDisciplines = discipline.filter((_) => _.parentIdentity === undefined);
		const subDisciplines = discipline.filter((_) => _.parentIdentity !== undefined);

		const orderedMaindisciplines = mainDisciplines.sort((current, next) => current.name.localeCompare(next.name));
		const orderedSubdisciplines = subDisciplines.sort((current, next) => current.name.localeCompare(next.name));

		const orderedDisciplines = orderedMaindisciplines.concat(orderedSubdisciplines);

		return orderedDisciplines;
	}
}

export default new DisciplineFilterOptionInformationFactory();
